"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishReason = void 0;
var FinishReason;
(function (FinishReason) {
    FinishReason[FinishReason["None"] = 1] = "None";
    FinishReason[FinishReason["StoppedByRemote"] = 2] = "StoppedByRemote";
    FinishReason[FinishReason["StoppedByEv"] = 3] = "StoppedByEv";
    FinishReason[FinishReason["StoppedByS3"] = 4] = "StoppedByS3";
    FinishReason[FinishReason["StoppedByError"] = 5] = "StoppedByError";
    FinishReason[FinishReason["StoppedByHmiInit"] = 6] = "StoppedByHmiInit";
    FinishReason[FinishReason["StoppedByPlcCommunicationError"] = 7] = "StoppedByPlcCommunicationError";
    FinishReason[FinishReason["StoppedByHmi"] = 8] = "StoppedByHmi";
    FinishReason[FinishReason["LockFault"] = 9] = "LockFault";
    FinishReason[FinishReason["TeslaCcsNotSupported"] = 10] = "TeslaCcsNotSupported";
})(FinishReason = exports.FinishReason || (exports.FinishReason = {}));
